import { css } from '@emotion/core';
import { StackView } from 'localmed-core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from '../../shared/components/DiComponents';
import { BackButton } from '../pages/SchedulingPage/components/styles';

interface Props {
  phone: string;
  done: () => void;
  action?: 'canceled' | 'rescheduled';
}

export default function SchedulingApptHasPassed({ phone, done, action = 'canceled' }: Props) {
  return (
    <StackView
      spacing="xl"
      mt="lg"
      css={css`
        text-align: center;
      `}
    >
      <Alert type="warning" p="md" my="md">
        <FormattedMessage
          id="scheduling.SchedulingApptHasPassed.appointmentPassed"
          defaultMessage="This appointment time has already occured and cannot be {action}. Please call {phone} if you have any questions concerning this appointment. "
          values={{
            phone,
            action,
          }}
        />
      </Alert>

      <BackButton onClick={done} variant="subtle" size="xl" aria-label="back button">
        <FormattedMessage
          id="scheduling.SchedulingApptHasPassed.keepAppointmentButton"
          defaultMessage="Done"
        />
      </BackButton>
    </StackView>
  );
}
